import { Action, createReducer, on } from '@ngrx/store';

import { SubmitOnlineBindRequestModel } from '@amfam/policy/models';
import { UnderwritingQuestion } from '@amfam/policy/vehicle/data-access';

import {
  ReplaceVehicleQuickQuoteContext,
  ReplaceVehicleQuickQuoteOperation
} from './quick-quote-enum';
import * as quickQuoteFeatureActions from './quick-quote-feature.actions';

export interface QuickQuoteFeatureState {
  vehicleId: string;
  underwritingQuestions?: UnderwritingQuestion[];
  context?: ReplaceVehicleQuickQuoteContext;
  operation?: ReplaceVehicleQuickQuoteOperation;
  quoteToBind?: SubmitOnlineBindRequestModel;
}

export const initialState: QuickQuoteFeatureState = {
  vehicleId: null,
  quoteToBind: null
};

const quickQuoteFeatureReducer = createReducer(
  initialState,
  on(quickQuoteFeatureActions.setVehicleId, (state, action) => ({
    ...state,
    vehicleId: action.vehicleId
  })),
  on(quickQuoteFeatureActions.setUnderWritingQuestions, (state, action) => ({
    ...state,
    underwritingQuestions: action.underwritingQuestions
  })),
  on(quickQuoteFeatureActions.setContext, (state, action) => ({
    ...state,
    context: action.context
  })),
  on(quickQuoteFeatureActions.setOperation, (state, action) => ({
    ...state,
    operation: action.operation
  })),
  on(quickQuoteFeatureActions.setQuote, (state, action) => ({
    ...state,
    quoteToBind: action.payload
  })),
  on(quickQuoteFeatureActions.resetQuickQuoteFeature, (state, action) => initialState)
);

export function reducer(state: QuickQuoteFeatureState | undefined, action: Action) {
  return quickQuoteFeatureReducer(state, action);
}
